module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/plan4-3-fc1e9a72cae9dafe43b7308156bb4483.webp";